import { defineComponent as _defineComponent } from 'vue'
export type HelpItems = Array<{ click: () => void; icon: string; name: string; }>
export type UserItems = Array<{ click: () => void; icon: string; name: string; active?: boolean; isLoading?: boolean; }>
import Logo from './Logo.vue';
import NavFooter from './NavFooter.vue';
import SupportContact from './SupportContact.vue';
import { computed } from 'vue';
import vuetify from '../../../service/useVuetify';
import NavItems from './NavItems.vue';
import { IntersectionStateChanger } from '@/utils/types';


export default /*#__PURE__*/_defineComponent({
  __name: 'MenuBar',
  props: {
    items: null,
    helpCenter: null,
    helpItems: null,
    userItems: null,
    email: null,
    phone: null,
    supportEmail: null,
    supportPhone: null,
    tooltips: null,
    userName: null,
    logoSmall: null,
    logoSmallWidth: { default: "40px" },
    logoSmallHeight: { default: "40px" },
    logoBig: null,
    logoBigWidth: { default: "120px" },
    logoBigHeight: { default: "44px" },
    logoMarginSM: { default: 'margin: 12px 4px' },
    logoMarginMD: { default: 'margin: 12px 8px' },
    logoMarginLG: { default: 'margin: 10px 56px 21px 38px' },
    logoMarginXL: { default: 'margin: 10px 76px 21px 59px' },
    isMini: { type: Boolean, default: false },
    isLogoLoading: { type: Boolean, default: false },
    altLogoSmall: null,
    altLogoBig: null
  },
  emits: ["on-click-logo", "on-shift-dblclick-logo", "get-subItemId-clicked", "updateMini", "infiniteHandler", "logout", "onusershiftdblclick"],
  setup(__props: any, { emit }: { emit: ({
  (e: "on-click-logo", event: Event): void;
  (e: "on-shift-dblclick-logo"): void;
  (e: "get-subItemId-clicked", index: number, subItemIndex?: number): void;
  (e: "updateMini", value: boolean): void;
  (e: "infiniteHandler", parentIndex: number, state: IntersectionStateChanger): void;
  (e: "logout"): void;
  (e: "onusershiftdblclick"): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { items: Array<any>, helpCenter: string, helpItems: HelpItems, userItems: UserItems, email: string, phone: string, supportEmail: string, supportPhone: string, tooltips: {
      expandTooltip: string,
      collapseTooltip: string,
      emailTooltip: string,
      phoneTooltip: string,
      profileTooltip: string,
    }, userName: string, logoSmall: string, logoSmallWidth: string, logoSmallHeight: string, logoBig: string, logoBigWidth: string, logoBigHeight: string, logoMarginSM: string, logoMarginMD: string, logoMarginLG: string, logoMarginXL: string, isMini: boolean, isLogoLoading:boolean, altLogoSmall?: string, altLogoBig?: string };





function infiniteHandler (parentIndex: number, state: IntersectionStateChanger) {
  emit('infiniteHandler', parentIndex, state);
}

function updateMini(value: boolean){
  emit('updateMini', value);
}

function subItemClicked(index: number, subItemIndex?: number) {
  emit('get-subItemId-clicked', index, subItemIndex);
}

const navigationWidth = computed(() => {
    switch (vuetify.value && vuetify.value.breakpoint.name) {
      case 'sm': return 48
      case 'md': return 56
      case 'lg': return 212
      case 'xl': return 252
      default: return 48
    }
})

return { __sfc: true,props, emit, infiniteHandler, updateMini, subItemClicked, navigationWidth, Logo, NavFooter, SupportContact, vuetify, NavItems }
}

})